import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SeatingChart from 'assets/svgs/seatingChart.svg';
import { Link } from 'react-router-dom';
import './RoomSeatingChart.scss';

const RoomSeatingChart = (props) => {
  const { t } = useTranslation();
  return (
    <div className="mt-24 room-seating-chart-section">
      <h5>{t('roomDashboard.seatingChart.title')}</h5>
      <div className="border-box-silver">
        <p>{t('roomDashboard.seatingChart.infoText')}</p>
        <Link
          href={`/test-event/${props.eventId}/room/${props.roomId}/seating-chart`}
          to={`/test-event/${props.eventId}/room/${props.roomId}/seating-chart`}
          className="btn-link icon-link">
          <SeatingChart className="svg-icon" />
          <span>{t('roomDashboard.seatingChart.manageSeatingLabel')}</span>
        </Link>
      </div>
    </div>
  );
};

export default RoomSeatingChart;

RoomSeatingChart.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  roomId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
